// Client-side search + sort for the Save collection pages (Pins, Community).
// Lists are loaded capped (first: 100), so filtering/sorting in the client keeps
// one implementation across persons, posts/projects and contacts. "Recently
// added" is intentionally omitted: the list queries don't return a pin/contact
// timestamp, so name A–Z / Z–A is the reliable, shared sort.

export type SortDir = "az" | "za";

export const SORT_OPTIONS: readonly { value: SortDir; labelId: string }[] = [
  { value: "az", labelId: "sort.nameAz" },
  { value: "za", labelId: "sort.nameZa" },
];

export function applySearchSort<T>(
  items: readonly T[],
  nameOf: (item: T) => string,
  term: string,
  sort: SortDir,
): T[] {
  const t = term.trim().toLowerCase();
  const out = t ? items.filter((x) => nameOf(x).toLowerCase().includes(t)) : items.slice();
  out.sort((a, b) =>
    sort === "az" ? nameOf(a).localeCompare(nameOf(b)) : nameOf(b).localeCompare(nameOf(a)),
  );
  return out;
}
